import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { FormInputSelectComponent } from '@fcom/service-forms/components/common/form-input-select.component';

import { TooltipOptions } from '../../tooltip';

@Component({
  selector: 'fin-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss'],
})
export class SelectInputComponent extends FormInputSelectComponent implements OnChanges {
  @Input()
  label: string;

  @Input()
  tooltipHeading: string;

  @Input()
  tooltipContent: string;

  @Input()
  tooltipOptions: TooltipOptions = {
    closeOnScroll: true,
  };

  @Input()
  disableLabel = false;

  @Input()
  disableSelectOption = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.required) {
      this.isRequired = this.fieldRequired;
    }

    if (!changes.options || changes.options.firstChange) {
      return;
    }

    /**
     * Without this delay then selecting the value does not update the DOM when the new options
     * have rendered.
     */
    setTimeout(() => {
      const hasValueInOptions = changes.options.currentValue.find((option) => option.value === this.ctrlField.value);

      if (!hasValueInOptions) {
        this.ctrlField.patchValue('');
      } else {
        this.ctrlField.patchValue(this.ctrlField.value);
      }
    }, 0);
  }
}
